import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { AvailableLanguages } from '@constants';
import { User, UserProcess } from '@interfaces';
import { TranslateService } from '@ngx-translate/core';

import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-perm-stay-step5',
  templateUrl: './perm-stay-step5.component.html',
  styleUrls: ['./perm-stay-step5.component.scss'],
})
export class PermStayStep5Component implements OnInit, AfterViewInit, OnDestroy {
  @Input() formGroup: FormGroup;
  @Input() mode: 'foreigner' | 'employee';
  @Input() user: User;
  @Input() userProcess: UserProcess;
  @Output() firstInputShiftTabPressed: EventEmitter<void> = new EventEmitter<void>();
  @Output() lastFieldTabPressed: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() toggleVerificationOfPersonalDetails: EventEmitter<void> = new EventEmitter();

  public controls: { [key: string]: FormControl } = {};
  public currentLang: AvailableLanguages;

  private destroy$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private readonly translateService: TranslateService) {}

  public ngOnInit(): void {
    this.currentLang = this.translateService.currentLang as AvailableLanguages;

    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(({ lang: langKey }) => {
      this.currentLang = langKey as AvailableLanguages;
    });

    Object.keys(this.formGroup.controls).forEach(fieldName => {
      this.controls[fieldName] = this.formGroup.controls[fieldName] as FormControl;
    });
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.hasAnyFieldAnyValue(this.formGroup.controls)) {
        this.formGroup.markAllAsTouched();
      }
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public firstInputKeydown($event: KeyboardEvent): void {
    // interested only in situation with usage of tab
    if ($event.key?.toLowerCase() !== 'tab') {
      return;
    }

    // if only tab pressed and no family members: (noFamilyMembersInPoland === true) - emit.lastFieldTabPressed
    if (!$event.shiftKey) {
      if (this.controls.noFamilyMembersInPoland.value === true) {
        this.emitLastFieldTabPressed($event);
      }
      return;
    }

    // if shift AND tab pressed - emit.firstInputShiftTabPressed
    this.firstInputShiftTabPressed.emit();
  }

  public emitLastFieldTabPressed($event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();

    this.lastFieldTabPressed.emit($event);
  }

  private hasAnyFieldAnyValue(controls: { [key: string]: AbstractControl }): boolean {
    return Object.keys(controls).some(controlName => {
      const val = controls[controlName].value;

      if (Array.isArray(val) && val.length > 0) {
        return true;
      }

      return val !== '' && val !== undefined && val !== null;
    });
  }
}
